import styled from 'styled-components';

const MapContainer = styled.div`
  .mapboxgl-ctrl-geolocate:disabled {
    display: none;
  }

  .map-popup {
    min-width: 250px;

    .mapboxgl-popup-tip {
      display: none;
    }
    .mapboxgl-popup-content {
      padding: 0; // children should handle padding
    }
  }
`;

export default MapContainer;
